import { Link, useSearchParams } from 'react-router-dom';

import { useEmbedBootstrap } from '../use-widget-bootstrap';
import { useWidgetSeo } from '../widget-hooks/use-widget-seo';
import { PATH } from '../widget-lib/path-routes';

/**
 * Канонический path для сценария «запись» без привязки к слоту в URL (глубокие ссылки, Capacitor/WebView).
 * Запись на конкретное занятие — /sessions/:slotId.
 */
export default function BookPage() {
  useWidgetSeo(
    'Онлайн-запись',
    'Запись на занятия и индивидуальные тренировки.'
  );
  const [searchParams] = useSearchParams();
  const qs = searchParams.toString();
  const suffix = qs ? `?${qs}` : '';
  const { bootstrapHint, orgSlug } = useEmbedBootstrap();

  if (bootstrapHint && !orgSlug) {
    return (
      <div className="space-y-3 w-full min-w-0">
        <h1 className="text-xl font-semibold tracking-tight">Запись</h1>
        <p className="text-sm text-[var(--text-muted)]">{bootstrapHint}</p>
      </div>
    );
  }

  return (
    <div className="space-y-5 w-full min-w-0">
      <div>
        <h1 className="text-xl font-semibold tracking-tight">Запись на занятие</h1>
        <p className="mt-1 text-sm text-[var(--text-muted)]">
          Выберите дату и время в расписании или сузьте список по услуге. Запись на конкретный слот
          открывается из карточки занятия.
        </p>
      </div>
      <ul className="space-y-3 text-sm">
        <li>
          <Link
            className="font-medium text-[var(--accent)] underline-offset-2 hover:underline"
            to={`${PATH.schedule}${suffix}`}
          >
            Расписание
          </Link>
          <span className="text-[var(--text-muted)]"> — календарь и слоты</span>
        </li>
        <li>
          <Link
            className="font-medium text-[var(--accent)] underline-offset-2 hover:underline"
            to={`${PATH.scheduleFilters}${suffix}`}
          >
            Фильтр по услуге
          </Link>
          <span className="text-[var(--text-muted)]"> — затем расписание с выбранной услугой</span>
        </li>
        <li>
          <Link
            className="font-medium text-[var(--accent)] underline-offset-2 hover:underline"
            to={`${PATH.services}${suffix}`}
          >
            Услуги
          </Link>
          <span className="text-[var(--text-muted)]"> — карточка услуги и переход к расписанию</span>
        </li>
      </ul>
    </div>
  );
}
